@if (!printMode) {
  <lib-validation-problems [saving$]="saving$"></lib-validation-problems>
}

<div class="flex-item-no-padding">
  <h3>{{ 'orders.reportRequestedFor' | transloco }}</h3>

  <div class="margin-bottom-5">
    <div class="flex-container">
      <span class="flex-item-3">{{ 'orders.name' | transloco }}</span>
      <span class="flex-item-4" data-testid="attestor-first-name-text">{{ order.ultimateBeneficialOwnershipRequest?.entityName }}</span>
    </div>
    @if (order.ultimateBeneficialOwnershipRequest?.entityNumber) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'orders.number' | transloco }}</span>
      <span class="flex-item-4" data-testid="attestor-middle-name-text">{{ order.ultimateBeneficialOwnershipRequest!.entityNumber }}</span>
    </div>
    }
  </div>

  @if (attestationRequestorDetailsVisible()) {
  <h3>{{ 'orders.requestingCorporation' | transloco }}</h3>
  <div class="margin-bottom-5">
    <div class="flex-container">
      <span class="flex-item-3">{{ 'common.labels.corporationNameDisplayed' | transloco }}</span>
      <span class="flex-item-4" data-testid="attestor-first-name-text">{{ order.ultimateBeneficialOwnershipRequest?.displayedCorpName }}</span>
    </div>
  </div>
  }

  @if (showBrand()) {
  <h3>{{ 'orders.branding' | transloco }}</h3>
  <div class="margin-bottom-5">
    <div class="flex-container">
      <span class="flex-item-3">{{ 'orders.brand' | transloco }}</span>
      <span class="flex-item-4" data-testid="brand-text">
        @if (brandLogoUrl) {
        <img class="brand-logo" [src]="brandLogoUrl" alt="" />
        } @else if (brand?.hexCode) {
        <span class="brand-swatch" [style.background-color]="'#' + brand?.hexCode"></span>
        }
        {{ brand?.name }}
      </span>
    </div>
  </div>
  }

  <h3>{{ 'orders.attestorDetails' | transloco }}</h3>
  <div class="margin-bottom-5">
    @if (order.parties?.at(0)?.firstName) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'orders.firstName' | transloco }}</span>
      <span class="flex-item-4" data-testid="attestor-first-name-text">{{ order.parties?.at(0)?.firstName }}</span>
    </div>
    }
    @if (order.parties?.at(0)?.middleName) {
      <div class="flex-container">
        <span class="flex-item-3">{{ 'orders.middleName' | transloco }}</span>
        <span class="flex-item-4" data-testid="attestor-middle-name-text">{{ order.parties?.at(0)?.middleName }}</span>
      </div>
    }
    <div class="flex-container">
      <span class="flex-item-3">{{ 'orders.lastName' | transloco }}</span>
      <span class="flex-item-4" data-testid="attestor-last-name-text">{{ order.parties?.at(0)?.lastName }}</span>
    </div>
    @if (showEmail()) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'common.labels.email2' | transloco }}</span>
      <span class="flex-item-4" data-testid="attestor-email-text">{{ order.parties?.at(0)?.contactDetails?.email }}</span>
    </div>
    }
    <div class="flex-container">
      <span class="flex-item-3">{{ 'orders.identityVerification' | transloco }}</span>
      <span class="flex-item-4" data-testid="attestor-idv-text">{{ mapIdRequirementString() }}</span>
    </div>
    @if (showTextMessageInFrench()){
    <div class="flex-container">
      <span class="flex-item-3">{{ 'orders.sendTextInFrench' | transloco }}</span>
      <span class="flex-item-4" data-testid="attestor-send-text-in-french-text">{{ (order.ultimateBeneficialOwnershipRequest?.sendTextInFrench ? 'common.buttons.yes' : 'common.buttons.no') | transloco }}</span>
    </div>
    }
    @if (attestorDetailedInformationVisible()) {
      <div class="flex-container">
        <span class="flex-item-3">{{ 'orders.phoneNumber' | transloco }}</span>
        <span class="flex-item-4" data-testid="attestor-phone-number-text">{{ order.parties?.at(0)?.contactDetails?.phoneNumber }}</span>
      </div>
    }
    @if (attestorDetailedInformationVisible()) {
      <div class="flex-container">
        <span class="flex-item-3">{{ 'orders.dateOfBirth' | transloco }}</span>
        <span class="flex-item-4" data-testid="attestor-date-of-birth-text">{{ displayBirthday() }}</span>
      </div>
    }
    @if (attestorDetailedInformationVisible()) {
      <div class="flex-container">
        <span class="flex-item-3">{{ 'orders.address' | transloco }}</span>
        <span class="flex-item-4" data-testid="attestor-address-text">{{ displayAddress($safeNavigationMigration(order.parties?.at(0)?.contactDetails?.address)!) }}</span>
      </div>
    }
  </div>

  <h3>{{ 'orders.riskTemplate' | transloco }}</h3>
  <div class="margin-bottom-5">
    <div class="flex-container">
      <span class="flex-item-3">{{ 'orders.template' | transloco }}</span>
      <span class="flex-item-4" data-testid="attestor-phone-number-text">{{ attestationTemplate?.name }}</span>
    </div>
  </div>

  <h3 class="section-title">{{ 'common.labels.financialRiskQuestions' | transloco }}</h3>
  @if (sortedRiskQuestions?.length) {
    <div class="margin-top-25">
      @for (atq of sortedRiskQuestions; track atq; let i = $index) {
        <div class="margin-sides-5">
          <div class="risk-title">
            {{ i + 1 }}. <span [innerHTML]="displayQuestion($safeNavigationMigration(atq?.financialRiskQuestion))"></span>@if (atq.financialRiskQuestion.isRequired) {
            <span class="required"> *</span>
          }
        </div>
        @if (atq?.financialRiskQuestion?.options?.length) {
          <mat-chip-set>
            @for (opt of atq.financialRiskQuestion.options; track opt) {
              <mat-chip
                >
                {{ displayOption(opt) }}
              </mat-chip>
            }
          </mat-chip-set>
        }
      </div>
    }
  </div>
} @else {
  <mat-card class="card empty">
    <div class="empty-state">
      <mat-icon>help_outline</mat-icon>
      <span>{{ 'orders.noFinancialRiskQuestionsAreAssociated' | transloco }}</span>
    </div>
  </mat-card>
}


<!-- Supporting Business Documents -->
<h3 class="section-title">{{ 'common.labels.supportingBusinessDocuments' | transloco }}</h3>

@if (supportingDocs?.length) {
  <mat-card class="card">
    <div class="table-wrapper">
      <table mat-table [dataSource]="supportingDocs" class="docs-table" [attr.aria-label]="'common.labels.supportingBusinessDocuments' | transloco">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'common.labels.document' | transloco }}</th>
          <td mat-cell *matCellDef="let row">
            {{ displayDocName(row) }} @if (row.supportingBusinessDocument.isRequired) {
            <span class="required"> *</span>
          }
        </td>
      </ng-container>
      <!-- Type Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef scope="col">{{ 'common.labels.type' | transloco }}</th>
        <td mat-cell *matCellDef="let row">
          {{ displayDocType(row) }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedDocColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedDocColumns;"></tr>
    </table>
  </div>
</mat-card>
} @else {
  <mat-card class="card empty">
    <div class="empty-state">
      <mat-icon>description</mat-icon>
      <span>{{ 'orders.noSupportingDocumentsAreAssociatedWith' | transloco }}</span>
    </div>
  </mat-card>
}

</div>